import { memo, useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { Button, Form, Input } from 'antd';

import { EMAIL_PLACEHOLDER } from '../../constants/common';
import messages from '../../constants/messages';

import AgreementField from '../../components/AgreementField';
import PasswordField from '../../components/PasswordField';

import OtpField from './OtpField';
import PhoneField from './PhoneField';
import { STEPS } from './constants';

function SignInForm({
  agreementFieldVisibility,
  formRef,
  loading,
  step,
  signIn,
  sendPhone,
  resendCode,
  verifyEmail,
  verifyPhone
}) {
  const [submittable, setSubmittable] = useState(false);
  const [emailOtp, setEmailOtp] = useState([]);
  const [phoneOtp, setPhoneOtp] = useState([]);

  const [form] = Form.useForm();

  if (formRef) formRef.current = form;

  const values = Form.useWatch([], form);

  useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setSubmittable?.(true))
      .catch(() => setSubmittable?.(false));
  }, [values]);

  const setOtp = useCallback((value, field) => {
    field === 'emailOtp' ? setEmailOtp(value) : setPhoneOtp(value);
  }, []);

  return (
    <Form form={form} id="loginform" layout="vertical" requiredMark={false} size="small">
      <Form.Item
        label="Email"
        name="email"
        colon={false}
        rules={[
          { required: true, message: messages.FIELD_REQUIRED('Email') },
          { type: 'email', message: messages.FIELD_INVALID('Email') }
        ]}>
        <Input size="large" addonBefore={<i className="fas fa-at"></i>} name="email" placeholder={EMAIL_PLACEHOLDER} />
      </Form.Item>

      <PasswordField name="password" rules={[{ required: true, message: messages.FIELD_REQUIRED('Password') }]} />

      {agreementFieldVisibility && <AgreementField name="isTermsAccepted" />}

      {step === STEPS.EMAIL_OTP && (
        <OtpField
          label="Verify your email"
          name="emailOtp"
          onInput={value => setOtp(value, 'emailOtp')}
          resendCode={() => resendCode('emailOtp')}
        />
      )}
      {(step === STEPS.PHONE || step === STEPS.PHONE_OTP) && <PhoneField label="Phone" name="phone" />}
      {step === STEPS.PHONE_OTP && (
        <OtpField
          label="Verify your phone"
          name="phoneOtp"
          onInput={value => setOtp(value, 'phoneOtp')}
          resendCode={() => resendCode('phoneOtp')}
        />
      )}

      <div className="d-flex justify-content-end mb-3">
        <Link to="/auth/recover-pwd">Forgot password?</Link>
      </div>

      <Button
        className="w-full mb-3"
        color="primary"
        size="large"
        variant="solid"
        disabled={
          !submittable ||
          loading ||
          (step === STEPS.EMAIL_OTP && emailOtp?.length < 6) ||
          (step === STEPS.PHONE_OTP && phoneOtp?.length < 6) ||
          (agreementFieldVisibility && !form.getFieldValue('isTermsAccepted'))
        }
        loading={loading}
        onClick={
          step === STEPS.EMAIL_OTP
            ? verifyEmail
            : step === STEPS.PHONE
              ? sendPhone
              : step === STEPS.PHONE_OTP
                ? verifyPhone
                : signIn
        }>
        {step === STEPS.EMAIL_OTP || step === STEPS.PHONE || step === STEPS.PHONE_OTP
          ? 'Continue'
          : loading
            ? 'Please wait...'
            : 'Sign In'}
      </Button>
    </Form>
  );
}

export default memo(SignInForm);
